import { lazyLoad } from '@react-page/core'
import createPlugin from './createPlugin'

import ImageCardsBlockRenderer from './Renderer/ImageCardsBlockRenderer'

const ImageCardsBlockForm = lazyLoad(() => import('./Form/ImageCardsBlockForm'))

const imageCardsBlockPlugin = settings =>
    createPlugin({
        Renderer: ImageCardsBlockRenderer,
        Controls: ImageCardsBlockForm,
        ...settings,
    })

const imageCardsBlock = imageCardsBlockPlugin()
export default imageCardsBlock

export { imageCardsBlockPlugin }
